import { gql } from "@apollo/client/core";

export const ME_CLIENT_LAWCASE_QUERY = gql`
  query {
    meClient {
      id
      name
      type

      # Personal Data
      firstName
      lastName
      birthDate
      birthPlace
      birthState
      birthCountry
      fiscalCode
      address
      city
      state
      zipCode
      country

      # Company Data
      officialName
      companyFiscalCode
      companyTvaNumber
      companyZipCode
      companyAddress
      companyCity
      companyCountry
      pecEmail
      lawcases {
        id
        title
        description
        countFolders
        countDocuments
      }
    }
  }
`;
